module.exports = __webpack_public_path__ + "img/room0.4b423e05.gif";